module.exports = __webpack_public_path__ + "static/img/03_06_advanced_comp.c4738b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/03_06_advanced_comp.png
// module id = XfUY
// module chunks = 13